import React, { useMemo, useEffect, useReducer } from "react";
import axios from "axios";
import {getEmptyInvite} from "../utils/InviteUtils";
import {get} from "../utils/OctoberApiUtils";

const initialInvitesState = {
  invite: localStorage.getItem('invite') ? JSON.parse(localStorage.getItem('invite')) : getEmptyInvite(),
  inviteTemplates: []
};

export const InvitesContext = React.createContext();
export const InviteActions = {
  INVITE_TYPES_LOAD_SUCCESS: 'INVITE_TYPES_LOAD_SUCCESS',
  CHANGE_VALUE: 'CHANGE_VALUE',
  INVITE_SAVED: 'INVITE_SAVED',
};
const invitesReducer =  (state, action) => {
  switch (action.type) {
    case InviteActions.INVITE_TYPES_LOAD_SUCCESS:
      return { ...state, inviteTemplates:action.inviteTemplates };
    case InviteActions.CHANGE_VALUE:
      return { ...state, invite: {...state.invite, [action.name]: action.value}};
    case InviteActions.INVITE_SAVED:
      return { ...state, invite: {...state.invite, id: action.id}};
    default:
      return state;
  }
};

export const InvitesProvider =  (props) => {
  const [state, dispatch] = useReducer(invitesReducer, initialInvitesState);
  const contextValue = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);

  // set invite local storage
  useEffect(() => {
    localStorage.setItem('invite', JSON.stringify(state.invite))
    localStorage.getItem('clear') && localStorage.clear();
  }, [state.invite])

  // get invites data from db
  useEffect(async () => {

   async function fetchData(){
     const result = await get('/api/react/add-event/invites');
     dispatch({ type: "INVITE_TYPES_LOAD_SUCCESS", inviteTemplates: result.data });
   }
    fetchData();
  }, []);

  return (
    <InvitesContext.Provider value={contextValue}>
      {props.children}
    </InvitesContext.Provider>
  )
};
